import React, { type JSX } from 'react';
import cn from 'classnames';

interface IColoredSlice {
  title: JSX.Element | string;
  content: JSX.Element;
  secondContent?: JSX.Element | null;
  areContentsReversed?: boolean;
  backgroundColor?: string | null;
  UNSAFE_className?: string;
}

const ColoredSlice: React.FC<IColoredSlice> = ({
  title,
  content,
  secondContent,
  areContentsReversed = false,
  backgroundColor,
  UNSAFE_className,
}) => {
  return (
    <div
      className={`
        tw-px-4 desktop:tw-px-[7vw] ${UNSAFE_className || ''}
        tw-bg-beige-200 tw-pb-10 tw-pt-8
      `}
      style={{ ...(backgroundColor && { backgroundColor }) }}
    >
      <div className="container tw-mx-auto tw-my-0 tw-max-w-[996px]">
        <div className="title-wrapper tw-mb-6 tw-text-center">
          {React.isValidElement(title) ? (
            title
          ) : (
            <h2 className="catchy-title">{title}</h2>
          )}
        </div>

        {secondContent ? (
          <div
            className={cn('columns tw-flex tw-gap-8', {
              'tw-flex-col-reverse desktop:tw-flex-row-reverse':
                areContentsReversed,
              'tw-flex-col desktop:tw-flex-row': !areContentsReversed,
            })}
          >
            <div className="desktop:tw-w-1/2">{content}</div>
            <div className="desktop:tw-w-1/2">{secondContent}</div>
          </div>
        ) : (
          <div>{content}</div>
        )}
      </div>
    </div>
  );
};

export default ColoredSlice;
